import { ErrorBannerProps } from "./ErrorBanner.types"
import PlusIcon from "../../media/PlusIcon"
import ErrorIcon from "../../media/ErrorIcon"
import "./ErrorBanner.css"

const ErrorBanner = (props: ErrorBannerProps) => {
  const { show, error, onClose } = props

  return (
    <div className={`error-banner-container ${show ? "show-banner" : "hide-banner"}`}>
      <div className="error-banner-content">
        <ErrorIcon />
        <p className="error-banner-message">{error.message}</p>
      </div>

      {onClose !== undefined && (
        <div className="hide-error-banner-icon" onClick={onClose}>
          <PlusIcon />
        </div>
      )}
    </div>
  )
}

export default ErrorBanner
